import {
    Sparkles,
    Wrench,
    Eye,
    DoorOpen,
    ClipboardList,
    Coffee,
    ArrowUpRight,
} from "lucide-react";

const SERVICOS = [
    {
        icon: Sparkles,
        title: "Limpeza e Conservação",
        desc: "Higienização de áreas internas e externas, copas e jardins.",
    },
    {
        icon: Wrench,
        title: "Manutenção Predial",
        desc: "Pequenos reparos e conservação com ações preventivas e corretivas.",
    },
    {
        icon: Eye,
        title: "Vigia",
        desc: "Segurança patrimonial preventiva com presença física e monitoramento.",
    },
    {
        icon: DoorOpen,
        title: "Portaria e Controle de Acesso",
        desc: "Gestão de entrada e saída de pessoas, veículos e fornecedores.",
    },
    {
        icon: ClipboardList,
        title: "Administrativos & Recepção",
        desc: "Apoio a rotinas administrativas, documentos e recepção de visitantes.",
    },
    {
        icon: Coffee,
        title: "Copa e Apoio a Eventos",
        desc: "Organização da copa, café e suporte completo para eventos corporativos.",
    },
];

export default function Servicos() {
    return (
        <section
            id="servicos"
            data-testid="servicos-section"
            className="relative border-t border-zinc-200 dark:border-white/5 bg-zinc-50 dark:bg-[#070707] py-20 sm:py-24"
        >
            <div className="max-w-7xl mx-auto px-6 sm:px-8 w-full">
                {/* Compact header */}
                <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4 mb-10">
                    <div className="max-w-2xl">
                        <span className="inline-block text-xs font-bold uppercase tracking-[0.22em] text-[#E89546]">
                            Serviços
                        </span>
                        <h2 className="font-heading mt-3 text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-zinc-950 dark:text-white leading-[1.05]">
                            Soluções operacionais que sustentam o seu negócio.
                        </h2>
                    </div>
                    <p className="text-zinc-600 dark:text-zinc-400 max-w-md text-sm sm:text-base">
                        Seis frentes de atuação, integradas ou contratadas individualmente, com equipes treinadas e SLAs claros.
                    </p>
                </div>

                {/* 3x2 grid with larger cards */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                    {SERVICOS.map((s, i) => (
                        <ServiceCard key={s.title} item={s} index={i} />
                    ))}
                </div>
            </div>
        </section>
    );
}

function ServiceCard({ item, index }) {
    const { icon: Icon, title, desc } = item;
    return (
        <article
            data-testid={`servico-card-${index}`}
            className="group relative overflow-hidden rounded-2xl border border-zinc-200 dark:border-white/5 bg-white dark:bg-[#0d0d0d] p-8 sm:p-10 hover:bg-zinc-50 dark:hover:bg-[#141414] hover:border-zinc-300 dark:hover:border-white/10 transition-all shadow-sm dark:shadow-none"
        >
            <div className="flex items-start justify-between gap-3">
                <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-2xl bg-[#E89546]/10 text-[#E89546] flex items-center justify-center shrink-0">
                    <Icon className="w-7 h-7 sm:w-8 sm:h-8" />
                </div>
                <ArrowUpRight className="w-5 h-5 text-zinc-400 dark:text-zinc-500 group-hover:text-[#E89546] group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
            </div>
            <h3 className="font-heading mt-6 text-xl sm:text-2xl font-bold text-zinc-950 dark:text-white tracking-tight leading-snug">
                {title}
            </h3>
            <p className="mt-3 text-zinc-600 dark:text-zinc-400 leading-relaxed text-sm sm:text-base">
                {desc}
            </p>
        </article>
    );
}
